export interface DocumentPath {
  ExpiryDate: string;
  Name: string;
  Number: string;
  Path: string;
  Type: string;
}
